import React from "react";
import { component_tool } from "@/tool";

const { WizDropdown, WizMenu, WizIcon } = component_tool;

export default function(activeKey) {

  const menu = (index, pIndex) => (
    <WizMenu>
      <WizMenu.Item onClick={ () => this.handleSelectConditionType(index, 0, pIndex) }>与</WizMenu.Item>
      <WizMenu.Item onClick={ () => this.handleSelectConditionType(index, 1, pIndex) }>或</WizMenu.Item>
    </WizMenu>
  );

  return [
    {
      title: '方式',
      name: 'isGroup',
      tableItem: {
        width: 130,
        render: (text, record, index) => !text ? '条件' : '组',
      }
    },
    {
      title: '条件类型',
      name: 'conditionType',
      tableItem: {
        width: 100,
        render: (text, record, index) => <WizDropdown overlay={menu(index, record.pIndex)}><a> { text === 0 ? '与' : '或' } <WizIcon type='down'/></a></WizDropdown>
      }
    },
    {
      title: '业务类型',
      name: 'conditionBizType',
      tableItem: {
        width: 150,
      },
      dict: this.config.map(val => ({ code: val.key, codeName: val.title }))
    },
    {
      title: '名称',
      name: 'conditionBizName',
      tableItem: {
        render: (text, record, index) => record.trainPathName ? `${record.trainPathName}->${record.conditionBizName}` : text
      }
    },
    
    {
      title: '操作',
      name: 'oprate',
      tableItem: {
        width: 150,
        render: (text, record, index) => record.isGroup ? 
          <React.Fragment>
            <a style={{ marginRight: 15 }} onClick={ () => this.handleAddCondition(index) }>添加条件</a>
            <a onClick={ () => this.handleDelete(index) }>删除</a>
          </React.Fragment>
        : <a onClick={ () => this.handleDelete(index, record.pIndex) }>删除</a>
      }
    },
  ]
}